
import { mapActions } from 'vuex'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'

export default {
  head() {
    return {
      link: [
        {
          rel: 'canonical',
          href: 'https://penthejourney.com' + this.$route.path,
        },
      ],
      title: 'Notebooks • Pen The Journey',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Choose your own size and layout from our wide variety of notebooks!',
        },
        /*         {
          hid: 'keywords',
          name: 'keywords',
          content: `${this.product.keywords}`,
        }, */
        //Facebook Open Graph Tags
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://penthejourney.com/notebooks/',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Notebooks ∙ Pen The Journey',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            'Choose your own size and layout from our wide variety of notebooks!',
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Pen The Journey',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://penthejourney.com/2.png',
        },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: 'image/jpg',
        },
        { hid: 'og:image:height', property: 'og:image:height', content: '720' },
        { hid: 'og:image:width', property: 'og:image:width', content: '720' },
        { hid: 'og:image:alt', property: 'og:image:alt', content: '' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        //Twitter tags
        {
          hid: 'twitter:card',
          name: 'twitter:type',
          content: 'summary_large_image',
        },
        {
          hid: 'twitter:url',
          name: 'twitter:url',
          content: 'https://penthejourney.com/notebooks/',
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: 'Notebooks ∙ Pen The Journey',
        },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content:
            'Choose your own size and layout from our wide variety of notebooks!',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: 'https://penthejourney.com/2.png',
        },
        { hid: 'twitter:image:alt', name: 'twitter:image:alt', content: '' },
      ],
    }
  },
  data() {
    return {
      planners: [],
      mdiChevronLeft,
      mdiChevronRight,
      model: null,
      test: [
        'https://images.unsplash.com/photo-1562217180-021f74991332?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
        'https://images.unsplash.com/photo-1558478551-be297c7bb253?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
        'https://images.unsplash.com/photo-1557815269-fd3801bb6a83?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
      ],
      media: [],
      index: null,
      showLightBoxOnDom: true,
      images: [
        {
          id: 1,
          url: 'https://yoohooworld.com/assets/images/vue_product_zoomer/normal_size/1.jpeg',
        },
        {
          id: 2,
          url: 'https://yoohooworld.com/assets/images/vue_product_zoomer/normal_size/2.jpeg',
        },
      ],
    }
  },
  methods: {
    ...mapActions('product', ['getProductCategory']),
    showLightBox() {
      this.showLightBoxOnDom = true
    },
    closeLightBox() {
      this.showLightBoxOnDom = false
      this.$refs.lightbox.closeLightBox()
    },
    async showImage(i, images) {
      this.media = []
      this.generateLightBoxImages(images)
      this.showLightBoxOnDom = true
      //this.$refs.lightbox.showImage(i)
      this.index = i;
    },
    generateLightBoxImages(images) {
      if (!images) return []
      this.media = images.map((i) => {
        if (!i)
          return {
            thumb: '',
            src: '',
            caption: '',
          }
        return {
          // For image
          thumb: i,
          src: i,
          caption: 'Product image', // Optional - supports HTML
          // srcset: '...' // Optional for displaying responsive images
        }
      })
    },
  },
  async fetch() {
    const { payload } = this.$nuxt.context
    if (payload) this.planners = { ...payload }
    try {
      const category = 'Notebooks';
      const pl = await this.getProductCategory(category);
      
      if (!pl.length) return
      this.planners = { ...pl }
    } catch (error) {
      console.error(error)
    }
  },
  fetchOnServer: process.env.NODE_ENV !== 'development',
}
